var CHART_TYPE = {
    PYRAMID: 'pyramid',
    SOLIDGAUGE: 'solidgauge',
    GAUGESERIES: 'gaugeseries',
    FUNNEL: 'funnel',
    COLUMNWITHTARGET: 'columnwithtarget',
    GAUGE: 'gauge',
    PYRAMID_CHART: 'PyramidChart',
    HEATMAP: 'heatmap',
    BULLET: 'bullet',
    COLUMN: 'column',
    RADIALBAR: 'radialbar',
    WATERFALL: 'waterfall'
};

var constants = {
    chartTypes: CHART_TYPE
};

export default constants;